var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.accounts,"loading":_vm.accountsLoading},on:{"click:row":_vm.goto},scopedSlots:_vm._u([{key:"item.account_id",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"body--text"},[_vm._v(_vm._s(item.account_id))])]}},{key:"item.business_name",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"body--text"},[_vm._v(_vm._s(item.business_name))])]}},{key:"item.customer_name",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"body--text"},[_vm._v(_vm._s(_vm.formatName(item.customer_name)))])]}},{key:"item.email_address",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"body--text"},[_vm._v(_vm._s(item.email_address))])]}}])})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }